module.exports = __webpack_public_path__ + "img/ic_videosekolah.37cf00e2.svg";